import React from 'react'
import _ from 'lodash'
import {
    selectCompareParts
} from '../table/compareSlice'
import { useSelector } from 'react-redux'
const CompareGoButton = ({ part_id, hash }) => {
    const compareParts = useSelector(selectCompareParts)
    const isPartsInCompare = _.size(compareParts) > 0
 
    const compareOpen = (isPartsInCompare) => (e) => {
        if(isPartsInCompare === true){
            window.open('/auto/search/compare/', '_blank')
        }
    }
    return (
        <>
            <button
                className={isPartsInCompare ? 'compare-go__button' : 'compare-go__button disbled'}
                disabled={!isPartsInCompare}
                onClick={compareOpen(isPartsInCompare)}
            >
                {isPartsInCompare ? (
                    <svg fill="#ffffff" width="16px" height="16px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 30.016h20v-4h-20v4zM0 22.016h28v-4h-28v4zM0 14.016h24v-4h-24v4zM0 6.016h32v-4h-32v4z"></path>
                    </svg>
                ) : (
                    <svg fill="#ffffff" width="16px" height="16px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 30.016h20v-4h-20v4zM0 22.016h28v-4h-28v4zM0 14.016h24v-4h-24v4zM0 6.016h32v-4h-32v4z"></path>
                    </svg>
                )}

                Перейти к сравнению

            </button>
        </>
    )
}

export default CompareGoButton
